import { type FormEvent, useState } from "react";
import { useNavigate } from "react-router-dom";
import { PageHeader } from "../components/layout";
import { adminApi, ApiError } from "../lib/api";
import { useAdminAuth } from "../lib/auth";

export function SecurityPage() {
  const navigate = useNavigate();
  const { token, logout } = useAdminAuth();
  const [currentPassword, setCurrentPassword] = useState("");
  const [newPassword, setNewPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [error, setError] = useState<string | null>(null);
  const [isSubmitting, setIsSubmitting] = useState(false);

  async function handleSubmit(event: FormEvent<HTMLFormElement>) {
    event.preventDefault();

    if (isSubmitting) return;

    setError(null);

    if (currentPassword.length < 1 || currentPassword.length > 128) {
      setError("Текущий пароль должен содержать от 1 до 128 символов");
      return;
    }

    if (newPassword !== confirmPassword) {
      setError("Новые пароли не совпадают");
      return;
    }

    if (newPassword.length < 12 || newPassword.length > 128) {
      setError("Новый пароль должен содержать от 12 до 128 символов");
      return;
    }

    if (!token) {
      setError("Сессия администратора завершена. Войдите снова.");
      return;
    }

    setIsSubmitting(true);
    try {
      await adminApi.changePassword(token, {
        currentPassword,
        newPassword,
        confirmPassword,
      });
      logout();
      navigate("/login?password_changed=1", { replace: true });
    } catch (err) {
      setError(
        err instanceof ApiError ? err.message : "Не удалось изменить пароль",
      );
    } finally {
      setIsSubmitting(false);
    }
  }

  return (
    <div className="max-w-2xl">
      <PageHeader
        title="Безопасность"
        description="Измените пароль своей учётной записи администратора."
      />

      <section className="panel p-4 sm:p-6">
        <form className="space-y-4" onSubmit={handleSubmit}>
          <label className="block space-y-1.5">
            <span className="text-sm font-medium">Текущий пароль</span>
            <input
              className="control"
              type="password"
              value={currentPassword}
              onChange={(event) => setCurrentPassword(event.target.value)}
              autoComplete="current-password"
              maxLength={128}
              required
            />
          </label>

          <label className="block space-y-1.5">
            <span className="text-sm font-medium">Новый пароль</span>
            <input
              className="control"
              type="password"
              value={newPassword}
              onChange={(event) => setNewPassword(event.target.value)}
              autoComplete="new-password"
              minLength={12}
              maxLength={128}
              required
            />
          </label>

          <label className="block space-y-1.5">
            <span className="text-sm font-medium">Повторите новый пароль</span>
            <input
              className="control"
              type="password"
              value={confirmPassword}
              onChange={(event) => setConfirmPassword(event.target.value)}
              autoComplete="new-password"
              minLength={12}
              maxLength={128}
              required
            />
          </label>

          {error ? (
            <p className="text-sm text-danger" role="alert">
              {error}
            </p>
          ) : null}

          <button
            className="inline-flex h-10 items-center justify-center rounded-md bg-primary px-4 text-sm font-medium text-primary-foreground disabled:opacity-60"
            disabled={isSubmitting}
            type="submit"
          >
            {isSubmitting ? "Изменяем..." : "Изменить пароль"}
          </button>
        </form>
      </section>
    </div>
  );
}
